<div class="loader-container">
    <div class="spinner"></div>
</div>